module.exports = __webpack_public_path__ + "img/program-mahjong.1e02e266.jpg";